/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */
import axios from "axios";
import { APIGateways } from "../../../utility/APIGateways";
import { getAuthHeader } from "../../../utility/auth";
import { v2, errorToObject } from "@prftesp/cle-logger";
import errorCodes from "../../../utility/errorCodes";

const COMPONENT_NAME = "adminCCPServices/VideoMeetingService";

export const createMeetingAndAddCustomerAndAgentAttendee = async (meetingConsts) => {
	try {
		const response = await axios.post(`${APIGateways.videoChimeEndpoint}`, meetingConsts, {
			headers: await getAuthHeader(),
		});
		return response.data;
	} catch (error) {
		v2.error(`Error Creating Video meeting`, {
			additionalData: { error: errorToObject(error) },
			componentName: COMPONENT_NAME,
			logCode: errorCodes.CHIME_VIDEO_CREATE_ERROR,
		});
		throw error;
	}
};

export async function endMeeting(meetingId) {
	if (meetingId) {
		try {
			const response = await axios.delete(`${APIGateways.videoChimeEndpoint}`, {
				headers: await getAuthHeader(),
				data: { meetingId },
			});
			return response.data;
		} catch (error) {
			v2.error(`Error Deleting Video meeting`, {
				additionalData: { error: errorToObject(error) },
				componentName: COMPONENT_NAME,
				logCode: errorCodes.CHIME_VIDEO_DELETE_ERROR,
			});
			throw error;
		}
	}
}
